<ng-container *ngIf="selectedAccount">

    <ng-container *ngIf="Banner">
        <div *ngIf="selectedAccount.Trial" class="accountTrialBanner"
            [ngClass]="{'is-expired': isExpired(selectedAccount.Expiry)}">
            <span>This is a trial account for PRISMPdM.</span>
            <span style="margin-left: 10px;font-weight: bold;">Trial Expiry Date: {{selectedAccount.Expiry |
                date:'dd-MMM-yyyy'}}</span>
        </div>
        <div *ngIf="!selectedAccount.Trial && isExpired(selectedAccount.Expiry)" class="accountTrialBanner is-expired">
            <span>This account has expired </span>
            <span style="margin-left: 10px;font-weight: bold;">Expiry Date: {{selectedAccount.Expiry |
                date:'dd-MMM-yyyy'}}</span>
        </div>
    </ng-container>

    <ng-container *ngIf="pill">
        <span *ngIf="selectedAccount.Trial">
            <small class="accountTrialPill" [ngClass]="{'is-expired': isExpired(selectedAccount.Expiry )}">Trial</small>
        </span>
        <span *ngIf="!selectedAccount.Trial && isExpired(selectedAccount.Expiry)">
            <small class="accountTrialPill is-expired">Account Expired</small>
        </span>
    </ng-container>

    <ng-container *ngIf="!pill && !Banner">
        <span>
            <span *ngIf="selectedAccount.Trial" class="accountTrialMessage"
                [ngClass]="{'is-expired': isExpired(selectedAccount.Expiry )}">
                {{ getTrialMessage("Trial Account", selectedAccount.Expiry) }}
            </span>
            <span *ngIf="!selectedAccount.Trial && isExpired(selectedAccount.Expiry)"
                class="accountTrialMessage is-expired">
                {{ getTrialMessage("Account", selectedAccount.Expiry) }}
            </span>
        </span>
    </ng-container>

</ng-container>